import { API_BASE_URL } from '../config';
export interface ReportItem {
   date: string;
   price: number;
  }

export const fetchReport = async (symbol: any, from: any = null, to: any=null): Promise<any> => {
    var API_URL = `${API_BASE_URL}/report/trending?symbol=${symbol}`; // Replace with your real endpoint
    if(from && to) {
      API_URL += `&from=${from}&to=${to}`;
    }
      try {
        const response = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
    
        if (!response.ok) {
          throw new Error(`API error: ${response.statusText}`);
        }
    
        const responseData = await response.json();
        var data = responseData.data;
        console.log('Response data:', data); // Log the response data for debugging
        return responseData.data as any; // Adjust based on actual response format
      } catch (error) {
        console.error('Error fetching price:', error);
        throw error;
      }
};

export const fetchCandleStickReport = async (symbol: string, from: string, to: string): Promise<any> => {
  var API_URL = `${API_BASE_URL}/report/candlestick?symbol=${symbol}`; // Replace with your real endpoint
  if(from && to) {
    API_URL += `&from=${from}&to=${to}`;
  }
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as any; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
};

export const fetchVolumeReport = async (symbol: string, from: string, to: string): Promise<any> => {
  var API_URL = `${API_BASE_URL}/report/volume?symbol=${symbol}`; // Replace with your real endpoint
  if(from && to) {
    API_URL += `&from=${from}&to=${to}`;
  }
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as any; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
};

export const fetchForeignVolumeReport = async (symbol: string, from: string, to: string): Promise<any> => {
  var API_URL = `${API_BASE_URL}/report/foreign-volume?symbol=${symbol}`; // Replace with your real endpoint
  if(from && to) {
    API_URL += `&from=${from}&to=${to}`;
  }
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as any; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
};

export const fetchBuySellReport = async (symbol: string, from: string, to: string): Promise<any> => {
  var API_URL = `${API_BASE_URL}/report/buy-sell?symbol=${symbol}`; // Replace with your real endpoint
  if(from && to) {
    API_URL += `&from=${from}&to=${to}`;
  }
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as any; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
}